import React from "react";
import "./SaveNF.scss";
import { ReactComponent as Arrow } from "./../../../assets/svg/arrow.svg";
import { Link } from "react-router-dom";
import dog from "../../../assets/images/dog.png";
import DefaultLayout from "../../components/Layouts/DefaultLayout";
import { useTranslation } from "react-i18next";

function SaveNF() {
  const { t } = useTranslation();

  return (
    <DefaultLayout>
      <section className="save-nf">
        <div className="container">
          <img src={dog} alt="dog" className="award" />
          <h1>{t("save-doc-title")}</h1>
          <p>{t("save-doc-text")}</p>
          <Link to="/home" className="row">
            <Arrow />
            <span>{t("go-back-home")}</span>
          </Link>
        </div>
      </section>
    </DefaultLayout>
  );
}

export default SaveNF;
